import { Component, OnInit } from '@angular/core';
import {Form} from '../_forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CampaignDomainService, CampaignService, LoaderService, StorageService} from '../_services';
import {
  SmartlinkPreviewData,
  SessionStartResponse,
  DeploymentLink,
  buildDeploymentLinkUrl,
  appendPreviewQueryParams,
  LinkCustomerMatchMethod,
} from '../_models';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './smartlink-preview.component.html',
  styleUrls: ['./smartlink-preview.component.css']
})
export class SmartlinkPreviewComponent extends Form implements OnInit {
  url: SafeResourceUrl = null;
  campaignId: string | number = null;
  previewData: SmartlinkPreviewData;

  private sessionParams: any = {};
  private domainId: string;
  private previewDomain: string = null;
  private matchMethod: LinkCustomerMatchMethod = null;

  constructor(
    protected router: Router,
    protected location: Location,
    private route: ActivatedRoute,
    protected alertService: AlertService,
    private campaignService: CampaignService,
    private domainService: CampaignDomainService,
    private loaderService: LoaderService,
    private sanitizer: DomSanitizer,
    private storageService: StorageService
  ) {
    super(alertService, router, location);
  }

  ngOnInit() {
    const campaign = this.campaignService.getCurrentCampaign();
    this.route.queryParams.subscribe(params => {
      this.campaignId = params['campaign'] || campaign.id;
      this.domainId = params['domain'];
      this.previewDomain = params['preview_domain'];
      this.matchMethod = params['match_method'] ? +params['match_method'] : null;
      this.getPreviewData();
      this.sessionParams = {
        tracking_source: params['tracking_source'],
        sid1: params['sid1'],
        sid2: params['sid2'],
        sid3: params['sid3'],
        step: params['step_key'],
        step_type: params['step_type'],
        session_type: params['session_type'],
        is_first_step: !!params['is_first_step'],
        language: params['language'],
        ticket_id: params['ticket_id'],
        offer_intent: params['offer_intent'],
      };

      if (this.previewData) {
        this.startSession(this.previewData);
      }
    },error => {
      this.handleError(error);
    });

    window.addEventListener("message", function(event) {
      if (event.data && event.data.type === "iframeHeight") {
        document.getElementById("iframe-preview-container").style.height =
          event.data.height + "px";
      }
    });
  }

  private getPreviewData() {
    this.previewData = this.domainId ? this.domainService.getSmartlinkPreviewData(this.domainId) :
      this.campaignService.getSmartlinkPreviewData(this.campaignId);
  }

  startSession(previewData: SmartlinkPreviewData) {
    const service = this.domainId ? this.domainService : this.campaignService;
    const id = this.domainId ? this.domainId : this.campaignId;

    if (this.previewDomain) {
      // open preview in a new browser window
      const link: DeploymentLink = {...this.sessionParams, ...previewData, match_method: this.matchMethod};
      this.previewData = previewData;
      service.setSmartlinkPreviewData(id, this.previewData);

      if (previewData.order_id) {
        previewData.order_number = previewData.order_id;
        previewData.order_id = null;
      }

      const previewUrl = buildDeploymentLinkUrl(link, this.previewDomain, null, previewData);
      window.open(previewUrl, '_blank');
    } else if (previewData.url) {
      // session url already generated - open it in iframe
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(appendPreviewQueryParams(previewData.url, previewData));
    } else {
      // generate a new session url and open it in iframe
      this.loaderService.show();
      const token = this.storageService.get('authToken');

      if (previewData.token) {
        this.storageService.set('authToken', previewData.token); // use session token to restore the session
      }

      const startParams = {};
      if (previewData.customer_id) {
        startParams['customer_id'] = previewData.customer_id;
      }
      if (previewData.email) {
        startParams['email'] = previewData.email;
      }
      if (previewData.phone) {
        startParams['phone'] = previewData.phone;
      }

      service.startSession(id, Object.assign(startParams, this.sessionParams))
        .subscribe((data: SessionStartResponse) => {
          this.storageService.set('authToken', token); // restore original token
          this.url = this.sanitizer.bypassSecurityTrustResourceUrl(appendPreviewQueryParams(data.url, previewData));
          console.log(this.url);
          previewData.token = data.token;
          previewData.url = data.url;
          this.previewData = previewData;
          service.setSmartlinkPreviewData(id, this.previewData);
          this.loaderService.hide();
        }, error => {
          this.storageService.set('authToken', token); // restore original token
          this.loaderService.hide();
          this.handleError(error)
        });
    }
  }

  createNewSession() {
    const service = this.domainId ? this.domainService : this.campaignService;
    const id = this.domainId ? this.domainId : this.campaignId;
    service.clearSmartlinkPreviewData(id);
    this.url = null;
    this.previewData = null;
  }
}
